import {Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {ProductSearchService} from "../../../services/product/ProductSearchService";
import {ProductSearchResponse} from "../../../model/product/ProductSearchResponse";
import {
  MatCard,
  MatCardContent,
  MatCardHeader,
  MatCardSubtitle,
  MatCardTitle,
  MatCardTitleGroup
} from "@angular/material/card";
import {NgForOf, NgIf} from "@angular/common";
import {setActiveConsumer} from "@angular/core/primitives/signals";
import {MtxPhotoviewer} from "@ng-matero/extensions/photoviewer";
import {URLS} from "../../../core/URLS";
import {SSOService} from "../../../services/sso/SSOService";
import {SessionManager} from "../../../manager/SessionManager";
import {debounceTime, distinctUntilChanged, Subject} from "rxjs";

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    ReactiveFormsModule,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardSubtitle,
    MatCardTitle,
    MatCardTitleGroup,
    NgForOf,
    NgIf,
    MtxPhotoviewer,
    RouterLink
  ],
  templateUrl: './search.component.html',
  styleUrl: './search.component.css',
  providers: [ProductSearchService, SSOService, SessionManager]
})
export class SearchComponent {

  page: number = 0
  pageSize: number = 20
  hasNext: boolean = false
  items: ProductSearchResponse[] = []

  searchQuery: string = ""
  userQuestionUpdate = new Subject<string>();

  photos(photos: [string]) {
    let images = []
    for (let i = 0; i < photos.length; i++) {
      images.push(
        {
          index: i,
          src: URLS.PHOTO_URL + photos[i],
        }
      )
    }
    return images
  }

  constructor(private route: ActivatedRoute,
              private productSearchService: ProductSearchService,
              private ssoService: SSOService) {
    ssoService.refresh()
    this.userQuestionUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.searchQuery = value
        this.load()
      });
  }

  load() {
    this.page = 0
    this.productSearchService.search(this.page, this.pageSize, this.searchQuery)
      .subscribe(response => {
        this.hasNext = !(response.data.length < this.pageSize)
        this.items = response.data
      })

  }

  next() {
    this.page = this.page + 1
    this.productSearchService.search(this.page, this.pageSize, this.searchQuery)
      .subscribe(response => {
        this.hasNext = !(response.data.length < this.pageSize)
        this.items = this.items.concat(response.data)
      })

  }

  protected readonly URLS = URLS;

}
